"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDetailsAttribute = void 0;
const react_1 = __importDefault(require("react"));
const product_details_attribute_values_component_1 = require("./product-details-attribute-values.component");
const product_details_attribute_styles_1 = require("./product-details-attribute.styles");
const useChangeAttributeValues_1 = require("./useChangeAttributeValues");
const hooks_1 = require("../../../../client/hooks");
const store_1 = require("../../../../../store");
const ProductDetailsAttribute = ({ label, disabled, productTreeNodeId, selectedValues, productId, }) => {
    const { refetchProductList, refetchProductDetails } = (0, hooks_1.useRefetchQueries)();
    const { refetchCounters } = (0, hooks_1.useRefetchCounters)();
    const selectedProductTreeNodeId = (0, store_1.useSelectedTreeNodeId)();
    const { isLoading: isUpdating, handleSelectionSave, } = (0, useChangeAttributeValues_1.useChangeAttributeValues)({
        label,
        productId,
        onComplete: (success) => __awaiter(void 0, void 0, void 0, function* () {
            if (success) {
                void refetchProductList(selectedProductTreeNodeId);
                void refetchCounters({ selectedTreeNodeId: selectedProductTreeNodeId, attributeName: label });
                yield refetchProductDetails(productId);
            }
        }),
    });
    return (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(product_details_attribute_styles_1.StyledAttributeTitle, null, label), react_1.default.createElement(product_details_attribute_values_component_1.ProductDetailsAttributeValues, { attributeName: label, productTreeNodeId: productTreeNodeId, disabled: disabled || isUpdating, initialSelectedValues: selectedValues, onSave: handleSelectionSave })));
};
exports.ProductDetailsAttribute = ProductDetailsAttribute;
